// extracted by mini-css-extract-plugin
module.exports = {"ArticleDate":"ArticleDate__2S5BO","ArticleDate__spacing_small":"ArticleDate__spacing_small__2S5BO"};